import { fetcher } from "helpers/fetcher";

import { TGetClientBasicInfoRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getClientBasicInfo = async (userId: string, language: string) => {
  return await fetcher<TGetClientBasicInfoRes, any>(
    ENDPOINT.USER.GET_CLIENT_BASIC_INFO,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_CLIENT_BASIC_INFO.version,
        [API_HEADER.USER_ID]: userId,
        [API_HEADER.LANGUAGE]: language,
      },
    }
  );
};

export const queryGetClientBasicInfo = async (
  userId: string,
  language: string
) => {
  return (await getClientBasicInfo(userId, language)).data;
};

queryGetClientBasicInfo._key = (userId: string, language: string) => [
  ENDPOINT.USER.GET_CLIENT_BASIC_INFO.url,
  userId,
  language,
];
